import React, { Component } from 'react';
import AddMilestoneModals from '../components/AddMilestoneModal';
import AddSubMilestoneModal from '../components/AddSubMilestoneModal';
import SelectMilestoneModal from '../components/SelectMilestoneModal';
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { MyPATLink } from '../../common';
import NoContent from './NoContent';
import WithContent from './WithContent';
import BackIcon from '@material-ui/icons/KeyboardBackspace';
import CourseMainPageCard from "../components/CourseMainPageCard";
import RevisionMilestone from '../components/RevisionMilestone'
import CoursePlaneRoadMap from '../containers/coursePlaneRoadMap';
import _ from 'lodash';
import cx from 'classnames';
import CourseDetailsDrawer from '../../course/components/CourseDetailsDrawer';
import {
	Edit as EditIcon,
} from '@material-ui/icons';


import courseService from '../services/courseService';
import ContentMoreMenu from '../components/CourseDetail/ContentMoreMenu'
import ContentShareModal from '../components/CourseDetail/ContentShareModel'
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import { usersList } from '../../mylibrary/actions/userActions';
import CourseCommentDialog from '../components/CourseCommentDialog';
import { getCourseID } from '../components/CourseDetail/commonFunction';
import MilestoneMoreMenu from '../components/CourseDetail/MilestoneMoreMenu';
let selArr: any = [];
import { styles } from '../styling/CourseDetail'
import { CourseMilestoneDetails, Chapter } from "../modals/CourseMilestoneDetail"
import { CourseBasicInfo, CourseDetailDefault } from "../modals/CourseBasicInfo";
import ResponseBasedACL from '../../acl/components/ResponseBasedACL';
import { setCourseData } from '../actions/courseSetData';
import ACL from '../../acl/components/ACL';

interface CourseDetailProps extends WithStyles<typeof styles> {
	courseData: CourseBasicInfo;
	match: any;
	history: any;
	setCourseData: Function;
	showMsg: (msg: string, vari: string) => void,
	usersList: () => void,
}

interface CourseDetailStates {
	hasContent: Boolean,
	addMilestoneOpen: Boolean,
	addSubMilestoneOpen: Boolean,
	selectMilestoneOpen: Boolean,
	revisionMilestoneOpen: Boolean,
	milestoneData: CourseMilestoneDetails[],
	courseDetails: Chapter[],
	courseTemplatesData: CourseBasicInfo[],
	isShareDialogOpen: boolean,
	isCommentDialogOpen: Boolean,
	previewMode: boolean,
	isDetailDrawerOpen: Boolean,
	isFilterDrawerOpen: Boolean,
	detailsData: CourseBasicInfo,
	mileStoneAction: string[],
	defaultMilestoneValue: CourseMilestoneDetails,
	unchecked: boolean
}

class CourseDetail extends Component<CourseDetailProps, CourseDetailStates> {

	constructor(props: CourseDetailProps) {
		super(props);
		this.state = {
			hasContent: true,
			addMilestoneOpen: false,
			addSubMilestoneOpen: false,
			selectMilestoneOpen: false,
			revisionMilestoneOpen: false,
			isCommentDialogOpen: false,
			milestoneData: [],
			courseDetails: [],
			courseTemplatesData: [],
			isShareDialogOpen: false,
			previewMode: false,
			isDetailDrawerOpen: false,
			isFilterDrawerOpen: false,
			detailsData: CourseDetailDefault,
			mileStoneAction: [],
			defaultMilestoneValue: CourseDetailDefault,
			unchecked: false,
		};
		this.openMilestoneHandler = this.openMilestoneHandler.bind(this);
		this.openMilestoneCloseHandler = this.openMilestoneCloseHandler.bind(this);
		this.openSubMilestoneHandler = this.openSubMilestoneHandler.bind(this);
		this.openSubMilestoneCloseHandler = this.openSubMilestoneCloseHandler.bind(this);
		this.openMilestoneAcoordingToLength = this.openMilestoneAcoordingToLength.bind(this);
		this.openSelectedMilestone = this.openSelectedMilestone.bind(this)
		this.selectMilestoneClose = this.selectMilestoneClose.bind(this)
		this.openRevisionHandler = this.openRevisionHandler.bind(this)
		this.openRevisionMilestoneCloseHandler = this.openRevisionMilestoneCloseHandler.bind(this)
		this.getPackageDetails = this.getPackageDetails.bind(this);
		this.openShareDialog = this.openShareDialog.bind(this);
		this.fromShareModelReturn = this.fromShareModelReturn.bind(this)
		this.handleDetailDrawerOpen = this.handleDetailDrawerOpen.bind(this);
		this.handleDetailDrawerClose = this.handleDetailDrawerClose.bind(this);
		this.refreshState = this.refreshState.bind(this);
		this.previewMode = this.previewMode.bind(this);
		this.fromMilestoneReturnAction = this.fromMilestoneReturnAction.bind(this);
		this.milestoneCommonAction = this.milestoneCommonAction.bind(this);
		this.resetSelection = this.resetSelection.bind(this);
		this.updateCourseData = this.updateCourseData.bind(this);
	}
	handleDetailDrawerOpen = (event: any, details: CourseBasicInfo) => {
		event.preventDefault();
		courseService.getPackageDetails(details._id).then((details: CourseBasicInfo) => {
			this.setState({
				isDetailDrawerOpen: true,
				detailsData: details
			});
		});
	};

	refreshState(event: any, details: any) {
		this.getPackageDetails(this.props.match.params.id)
		this.updateCourseData();
	}


	handleDetailDrawerClose = (event: any) => {

		this.setState({
			isDetailDrawerOpen: false,
		});
	};

	componentDidMount() {
		this.props.usersList();
		(this.props.courseData).status == "PUBLISHED" ? this.setState({ previewMode: true }) : this.setState({ previewMode: false })
		this.updateCourseData();
	}

	openShareDialog(returnValue: Boolean) {
		if (returnValue) {

		} else {
			this.setState({
				isShareDialogOpen: false
			})
		}

	}
	openRevisionHandler = () => {
		this.setState({
			revisionMilestoneOpen: true
		})
	}

	openRevisionMilestoneCloseHandler() {
		this.setState({
			revisionMilestoneOpen: false
		})
	}

	openMilestoneHandler = () => {
		this.setState({
			addMilestoneOpen: true,
			defaultMilestoneValue: CourseDetailDefault
		})
	}

	openMilestoneCloseHandler() {
		this.setState({
			addMilestoneOpen: false
		})
		this.getPackageDetails(this.props.match.params.id)
		this.updateCourseData();
		this.resetSelection();
	}

	openSubMilestoneHandler = () => {
		this.setState({
			addSubMilestoneOpen: true
		})
	}

	openSubMilestoneCloseHandler() {
		this.setState({
			addSubMilestoneOpen: false
		})
	}

	openSelectMilestone = () => {
		this.setState({
			selectMilestoneOpen: true
		})
	}

	selectMilestoneClose() {
		this.setState({
			selectMilestoneOpen: false
		})
	}

	openMilestoneAcoordingToLength() {
		let length = this.state.milestoneData.length;
		if (length > 0) {
			this.openSelectMilestone()
		} else {
			this.openMilestoneHandler()
		}
	}

	openSelectedMilestone(value: string) {
		if (value == "progressMilestone") {
			this.openMilestoneHandler()
		} else if (value == "subMilestone") {
			this.openSubMilestoneHandler()
		} else if (value == "reviewMilestone") {
			this.openRevisionHandler()
		}
	}
	getPackageDetails(value: string) {
		var self = this;
		courseService.getPackagePlan(value).then((chapters: any) => {
			self.setState({
				milestoneData: chapters.milestones || []
				, courseDetails: chapters || []
			})
		});
	}

	updateCourseData() {
		var self = this;
		courseService.getPackageDetails(this.props.match.params.id).then((details: CourseBasicInfo) => {
			self.props.setCourseData(details)
		});
	}

	handleEditClick() {

	}

	handlePublishClick() {
		var self = this;
		var courseID = this.props.match.params.id || getCourseID()

		courseService.publishPackage(courseID).then((responseData: any) => {

			if (responseData.statusCode === 200) {
				if (!_.isEmpty(responseData.responseObject)) {
					self.props.showMsg("Course Successfully Published !", 'success');
				}
			} else {
				self.props.showMsg("Something went wrong! Please try again later", 'error');
			}
		});
	}

	previewMode() {
		this.setState({
			previewMode: !this.state.previewMode
		})
	}

	componentWillMount() {
		this.getPackageDetails(this.props.match.params.id)
		courseService.getCourseTemplates().then((courseTemplates: any) => {
			var self = this;
			self.setState({ courseTemplatesData: courseTemplates })
		});
	}
	showMilestone = (param: any) => {
		const returnArr: any = [];
		param = param || "";
		try {
			if (param != "") {
				param.map(function (v: any, p: any) {
					returnArr.push(v.name);
				});
			}
		} catch (e) {

		}

		return returnArr;
	};

	fromShareModelReturn(value: string) {
		var self = this;
		if (value == "Share") {
			this.setState({
				isShareDialogOpen: true
			})
		}
		else if (value == "Comment") {
			this.setState({
				isCommentDialogOpen: true
			})
		}
		else if (value == "Copy Course") {
			courseService.copyCourse(this.props.match.params.id).then((response: any) => {
				self.props.showMsg("Course Successfully copied", 'success');
			});
		}
		else {
			courseService.archiveCourse(this.props.match.params.id).then((response: any) => {
				self.props.showMsg("Course Successfully archived", 'success');
				this.props.history.goBack();
			});
		}
	}
	fromMilestoneReturnAction(value: string) {
		var self = this;

		if (this.state.mileStoneAction.length == 0) {
			self.props.showMsg("No milestone selected !", 'error');
			return
		}
		if (value == "Combine") {
			if (this.state.mileStoneAction.length > 0) {
				let body = {
					"packageId": self.props.match.params.id,
					"milestone1": self.state.mileStoneAction[0],
					"milestone2": self.state.mileStoneAction[1]
				}
				courseService.combineMilestone(body).then((response: any) => {
					if (response) {
						self.props.showMsg("Milestone has been combined successfuly !", 'success');
					}
					else {
						self.props.showMsg("Something went wrong! Please try again later", 'error');
					}
					self.setState({ mileStoneAction: [] })
					self.refreshState("", "");
				});
			}

		}
		else if (value == "Delete") {
			courseService.deleteMilestone(self.props.match.params.id, self.state.mileStoneAction[0]).then((response: any) => {
				if (response) {
					self.props.showMsg("Milestone has been deleted successfuly !", 'success');
				}
				else {
					self.props.showMsg("Something went wrong! Please try again later", 'error');
				}
				self.setState({ mileStoneAction: [] })
				self.refreshState("", "");
			});
		}
		else if (value == "Edit") {
			const { mileStoneAction, milestoneData } = this.state
			var getArr = milestoneData.filter(function (v: any) {
				return v._id == (mileStoneAction[0] || "")
			})

			this.setState({
				defaultMilestoneValue: getArr[0],
				addMilestoneOpen: true,
			})
		}
		else if (value == "Cancel") {
			self.resetSelection()
		}
	}
	resetSelection() {

		this.setState(
			{
				mileStoneAction: [],

			}
		)
	}
	milestoneCommonAction(e: any) {
		let self = this;
		let selectedValue = "";
		selArr = self.state.mileStoneAction;
		let index = selArr.indexOf(e.target.value);

		if (e.target.checked && index == -1) {
			selArr.push(e.target.value)
		}
		else {
			selArr = selArr.filter(function (v: any) {
				return v != e.target.value
			})
		}
		self.setState(() => ({ mileStoneAction: selArr }))
	}

	handleCommentDialogClose() {
		this.setState({
			isCommentDialogOpen: false
		})
	}

	closeShare() {
		this.setState({
			isShareDialogOpen: false
		})
	}
	render() {
		let { classes, courseData } = this.props;
		let { courseTemplatesData, isShareDialogOpen, previewMode, unchecked } = this.state;
		courseTemplatesData = courseTemplatesData || []
		if (_.isEmpty(courseData)) {
			courseData = JSON.parse(localStorage.getItem("myPatCourse") || "")
		}

		if (_.isEmpty(courseData)) {
			return ""
		}
		const { hasContent, addMilestoneOpen, addSubMilestoneOpen, selectMilestoneOpen, revisionMilestoneOpen, isCommentDialogOpen, mileStoneAction, milestoneData } = this.state;
		const Content = hasContent ? <WithContent /> : <NoContent />;

		var courseID = this.props.match.params.id || getCourseID()

		return (
			<>
				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12} className={classes.wrapperMain}>

						<Grid xs={12}
							container
							direction="row"
							alignContent="center"
							justify="space-between"
						>
							<Grid xs={4} >
								{/* <MyPATLink to={`/course/`}>
									<Typography variant="h6" style={{ padding: "10px", color: "#000000" }}>
										<BackIcon /> Course Basic Details
									</Typography>
								</MyPATLink> */}
							</Grid>
							<Grid xs={6} container justify="flex-end" alignItems="flex-end">


									<Button
										variant="outlined"
										disabled={previewMode ? false : true}
										onClick={this.previewMode}
									>
										<div className={classes.editText}>
											<EditIcon className={classes.editTextIcons} />
										</div>
										Edit
									</Button>


									<Button
										variant="contained"
										type="submit"
										color="primary"
										disabled={previewMode ? true : (courseData.draftCompletionPercentage == 100 ? false : true)}
										onClick={this.handlePublishClick.bind(this)}
										style={{ marginLeft: "15px" }}
									>
										Publish
									</Button>
								{
									courseData.draftCompletionPercentage != 100 && courseData.status == "DRAFT"
										?
										<div className={classes.incompleteDraft}>
											<Typography variant="caption">Incomplete Draft</Typography>
										</div>
										:
										<></>
								}

								<div style={previewMode ? { pointerEvents: 'none' } : {}}>
									<ContentMoreMenu clicked={this.fromShareModelReturn} />
								</div>
							</Grid>
						</Grid>
						<AddMilestoneModals
							addMilestoneOpen={addMilestoneOpen}
							addMilestoneCloseHandler={this.openMilestoneCloseHandler}
							editModeValue={this.state.defaultMilestoneValue}
							startDate={_.get(this.props, 'courseData.startDate', '')}
							courseID={courseID}
						/>
						<AddSubMilestoneModal
							addSubMilestoneOpen={addSubMilestoneOpen}
							addSubMilestoneCloseHandler={this.openSubMilestoneCloseHandler}
							milestoneData={this.state.milestoneData}
							courseID={courseID}
							startDate={_.get(this.props, 'courseData.startDate', '')}
						/>
						<SelectMilestoneModal
							selectMilestone={selectMilestoneOpen}
							closeSelectMilestone={this.selectMilestoneClose}
							openSelectedMilestone={this.openSelectedMilestone}
						/>
						<RevisionMilestone
							revisionMilestoneOpen={revisionMilestoneOpen}
							revisionMilestoneCloseHandler={this.openRevisionMilestoneCloseHandler}
							milestoneData={this.state.milestoneData}
							courseID={courseID}
							startDate={_.get(this.props, 'courseData.startDate', '')}
						/>

						{isCommentDialogOpen &&
							<CourseCommentDialog
								isDialogOpen={isCommentDialogOpen}
								dialogCloseHandler={this.handleCommentDialogClose.bind(this)}
								courseID={courseID}
							/>}

						<ContentShareModal functionCall={this.updateCourseData} courseID={courseID} isShareDialogOpen={isShareDialogOpen} closeDialog={this.closeShare.bind(this)} onShared={this.openShareDialog} />

						<div key={1}>
							<Paper elevation={0} style={{ marginBottom: 10 }}>
								<ListItem>
									<CourseMainPageCard cardFlag="" batchesData={[]} cardDetails={courseData} />
								</ListItem>
							</Paper>
						</div>
						<Grid xs={12}
							container
							direction="row"
							alignContent="center"
							justify="space-between"
						>
							<Grid xs={12} style={previewMode ? { pointerEvents: 'none' } : {}} container justify="flex-end" alignItems="flex-end">
								<MyPATLink disabled to={`/course/advancesetting/${courseID}`} className="{classes.gapRgt}">
									<Button color="primary" className="{classes.advance_settings}" disabled={previewMode ? true : false} >
										Advanced Settings
									</Button>
								</MyPATLink>
							</Grid>
						</Grid>
					</Grid>
				</Grid>

				<Grid container
					spacing={0}
					direction="column"
					className={classes.root}>
					<Grid item xs={12} className={classes.wrapperMain} style={{ marginTop: "20px" }}>
						<Grid xs={12}
							container
							direction="row"
							alignContent="center"
							justify="space-between"
						>
							<Grid xs={4}>
								<Typography variant="h6" style={{ padding: "10px" }}>
									Course Plan
								</Typography>
							</Grid>
							<Grid xs={6} style={{ padding: "10px" }} container justify="flex-end" alignItems="flex-end">


								<ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<Button
										variant="contained"
										type="submit"
										color="primary"
										disabled={previewMode ? true : false}
										style={{ marginLeft: "15px" }}
										onClick={this.openMilestoneAcoordingToLength.bind(this)}
									>
										Add Milestone
									</Button>
								</ResponseBasedACL>

								<ResponseBasedACL
									response={_.get(courseData, 'aclMetaData', {})}
									responseKey='allowedTo'
									accessType={['EDIT']}
								>
									<div style={previewMode ? { pointerEvents: 'none' } : {}}>
										<MilestoneMoreMenu
											mileStoneAction={mileStoneAction}
											clicked={this.fromMilestoneReturnAction}
											mileStoneLength={mileStoneAction.length} />
									</div>
								</ResponseBasedACL>

							</Grid>

						</Grid>

						{

							mileStoneAction.length >= 2
								?
								<Grid container justify="flex-end" alignItems="flex-end">
									{mileStoneAction.length > 1 ? <Grid style={{ marginRight: "10px" }} >{mileStoneAction.length} Selected </Grid> : ""}
									<ResponseBasedACL
										response={_.get(courseData, 'aclMetaData', {})}
										responseKey='allowedTo'
										accessType={['EDIT']}
									>
										<Button
											variant="contained"
											type="submit"
											color="primary"
											// disabled = {mileStoneAction.length>=2 ? false : true}
											className={classes.combineButton}
											onClick={(e: any) => this.fromMilestoneReturnAction('Combine')}
										>
											Combine
								</Button>
									</ResponseBasedACL>
									<br />
									<ResponseBasedACL
										response={_.get(courseData, 'aclMetaData', {})}
										responseKey='allowedTo'
										accessType={['EDIT']}
									>
										<div onClick={() => this.resetSelection()} className={classes.cancelButton}>
											Cancel
								</div>
									</ResponseBasedACL>

								</Grid>
								: ""}

						{this.state.milestoneData.length > 0 ?
							<Grid container alignItems="center" justify="center" xs={12} >
								<CoursePlaneRoadMap milestoneCommonAction={this.milestoneCommonAction} courseDetails={this.state.courseDetails} milestoneData={this.state.milestoneData} courseID={courseID}
									mileStoneAction={this.state.mileStoneAction}
									mileStoneActionLength={this.state.mileStoneAction.length} />
							</Grid>

							: <Grid container alignItems="center" justify="center" xs={12}>
								<img style={{ height: "300px", width: "300px" }} onClick={this.openMilestoneAcoordingToLength.bind(this)} src="/assets/img/course/milestone_new.png" alt="Milestone" />
								<Grid container align-items-xs-center="true">
									<Typography variant="h6" style={{ padding: "10px", textAlign: "center", width: "100%" }}>
										Plan Better! Track Smarter!
								</Typography>
								</Grid>
								<Grid container align-items-xs-center="true">
									<Typography variant="h6" style={{ textAlign: "center", width: "100%", fontWeight: "normal", fontSize: "12px", fontColor: "#999999", marginTop: "15px" }}>
										Plan your Course by setting up multiple milestones which end with milestone tests<br />and breaks the syllabus into manageable chunks.
								</Typography>
								</Grid>
							</Grid>
						}

						{this.state.milestoneData.length == 0 ?
							<Grid xs={12}
								container
								direction="row"
								alignContent="center"
								justify="space-between"
							>
								<Grid xs={4}>
									<Typography variant="h6" style={{ padding: "10px" }}>
										Course Templates
								</Typography>
								</Grid>
								<Grid xs={12}>
									<div>
										<Paper elevation={0} style={{ marginBottom: 10 }}>
											{
												courseTemplatesData.map((value: any, index: any) => {
													return <ListItem className={classes.borderDefault}>
														<Grid item xs={12} container className={classes.leftDisplay}>
															<Grid item xs={8} >
																<Grid item xs={12}>
																	<Typography variant="body2" className={cx(classes.textEllipsis)}>{value.name}</Typography>
																</Grid>
																<Grid item xs={12}>
																	<Typography variant="body2" className={classes.subTitle}>
																		{this.showMilestone(value.milestones).join(', ')}
																	</Typography>
																</Grid>
															</Grid>
															<Grid item xs={4}>
																<Grid item xs={12} className={classes.previewBtn}>
																	<div className="content-preview">
																		<MyPATLink onClick={(e: any) => this.refreshState(e, value)} to={'/course/detail/' + value._id}>
																			<Button variant="contained" size="medium" className={classes.previewButton}>
																				Select
													</Button>
																		</MyPATLink>
																		<br />
																		<MyPATLink to="" onClick={(e: any) => this.handleDetailDrawerOpen(e, value)} displayProp="inline-block" className={classes.viewDetails}> View Detail
												</MyPATLink>
																	</div>
																</Grid>
															</Grid>
														</Grid>
													</ListItem>
												})
											}
										</Paper>
									</div>
								</Grid>
							</Grid>
							: ""}
					</Grid>
					<CourseDetailsDrawer
						onDetailDrawerClose={this.handleDetailDrawerClose.bind(this)}
						isDetailsDrawerOpen={this.state.isDetailDrawerOpen}
						drawerData={this.state.detailsData}
					/>
				</Grid>
			</>
		)
	}
}

const mapStateToProps = (state: any) => ({
	courseData: state.courseData.courseData.list
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg,
		usersList,
		setCourseData: setCourseData
		// ServerAlertAction
	},
	dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CourseDetail));

